// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unit-per-pitch[data-v-6e864846]{font-size:var(--body);position:relative}.unit-per-pitch[data-v-6e864846] aside{margin:0 0 0 .5em}.one-unit-per-pitch[data-v-6e864846]{margin:1em 0}.one-unit-per-pitch p[data-v-6e864846]{font-size:var(--body);margin-top:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
